// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*start of committee letters css */
.lsn-question-group-committee {
  margin-bottom: 2rem;
  /*end of committee letters css */
}
.lsn-question-group-committee .lsn-committeeMember {
  display: flex;
  flex-flow: row nowrap;
}
.lsn-question-group-committee .lsn-committee-members-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.lsn-question-group-committee .lsn-committeeMember {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 55px;
  align-items: baseline;
}
.lsn-question-group-committee .lsn-committeeMember.lsn-form-group.form-group {
  margin-bottom: 0.8rem;
}
.lsn-question-group-committee .lsn-committeeMember-header .lsn-form-group.form-group {
  margin-bottom: 0;
}
.lsn-question-group-committee .lsn-control-input-text:disabled {
  border: 0;
}
.lsn-question-group-committee .lsn-committeeMember-addMemberButton:disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: var(--main-light-gray);
}
.lsn-question-group-committee .buttons-wrapper {
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.lsn-question-group-committee .fa-exclamation-triangle {
  margin-right: 0.6rem;
}
.lsn-question-group-committee .max-items-added-warning-label {
  color: var(--main-orange);
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/AddMember/AddMember.less"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,mBAAA;EACA,gCAAgC;AAClC;AAHA;EAII,aAAA;EACA,qBAAA;AAEJ;AAPA;EASI,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,SAAA;AACJ;AAbA;EAgBI,aAAA;EACA,SAAA;EACA,+BAAA;EACA,qBAAA;AAAJ;AAEI;EACE,qBAAA;AAAN;AAtBA;EA2BI,gBAAA;AAFJ;AAzBA;EA+BI,SAAA;AAHJ;AASI;EACE,mBAAA;EACA,oBAAA;EACA,wCAAA;AAPN;AAjCA;EA6CI,aAAA;EACA,mBAAA;EACA,gBAAA;AATJ;AAtCA;EAmDI,oBAAA;AAVJ;AAzCA;EAuDI,yBAAA;AAXJ","sourcesContent":["/*start of committee letters css */\n.lsn-question-group-committee {\n  margin-bottom: 2rem;\n\n  .lsn-committeeMember {\n    display: flex;\n    flex-flow: row nowrap;\n  }\n\n  .lsn-committee-members-grid {\n    margin-top: 1rem;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .lsn-committeeMember {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: 1fr 55px;\n    align-items: baseline;\n\n    &.lsn-form-group.form-group {\n      margin-bottom: .8rem;\n    }\n  }\n\n  .lsn-committeeMember-header .lsn-form-group.form-group {\n    margin-bottom: 0;\n  }\n\n  .lsn-control-input-text:disabled {\n    border: 0;\n  }\n\n  .lsn-committeeMember-addMemberButton {\n    // width: auto;\n\n    &:disabled {\n      cursor: not-allowed;\n      pointer-events: none;\n      background-color: var(--main-light-gray);\n    }\n  }\n\n  .buttons-wrapper {\n    display: flex;\n    align-items: center;\n    column-gap: 20px;\n  }\n\n  .fa-exclamation-triangle {\n    margin-right: .6rem;\n  }\n\n  .max-items-added-warning-label {\n    color: var(--main-orange);\n  }\n\n  /*end of committee letters css */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
